export default {
  content: {
    padding: [0, 20],
    overflow: 'visible',
    margin: 0
  },
  withBorder: {
    borderBottom: '1px solid #ccc',
    marginBottom: 10
  },
  root: {
    '& $withBorder:last-child': {
      border: 'none'
    }
  },
  header: {
    '& span': {
      fontSize: 16,
      fontWeight: 'bold'
    },
    '& button': {
      '& > div': {
        padding: 0
      },
      lineHeight: '22px'
    },
    '&.nested': {
      '& span': {
        fontSize: 14
      }
    }
  },
  innerContent: {
    overflow: 'visible',
    margin: 0
  }
};
